<template>
  <healthcheck-form
    :healthcheck-id="healthcheckId"
    details
    @submit="update"
    @close="onClose"
  />
</template>
<script>
import HealthcheckForm from '../Form.vue'

export default {
  name: 'EditHealthcheck',
  components: {
    HealthcheckForm,
  },
  data() {
    return {
      healthcheckId: null,
    }
  },
  created() {
    this.healthcheckId = Number(this.$route.params.healthcheckId)
  },
  methods: {
    update(healthcheck) {
      const query = {
        id: this.healthcheckId,
        healthcheck: {
          name: healthcheck.name,
          url: healthcheck.url,
          protocol: healthcheck.protocol,
          method: healthcheck.method,
          expectedResponse: healthcheck.expectedResponse,
          expectedBody: healthcheck.expectedBody,
          matchWholeBody: healthcheck.matchWholeBody,
          headers: healthcheck.headers,
          body: healthcheck.body || null,
          scheduleType: healthcheck.scheduleType,
          interval: healthcheck.interval || 1,
          timeout: healthcheck.timeout,
          state: healthcheck.state,
          certificateVerification: healthcheck.certificateVerification,
          followRedirects: healthcheck.followRedirects,
          followHttpMethod: healthcheck.followHttpMethod,
          followAuthorizationHeader: healthcheck.followAuthorizationHeader,
          removeRefererOnRedirect: healthcheck.removeRefererOnRedirect,
          groupId: healthcheck.groupId,
          retries: healthcheck.retries,
          dataCenters: healthcheck.dataCenters,
        },
      }
      this.$store
        .dispatch('healthchecks/updateHealthcheck', query)
        .then(() => {
          this.successToast('Healthcheck was updated')
          this.onClose()
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating healthcheck.')
        })
    },
    onClose() {
      this.$router.push({
        name: 'healthchecks',
      })
    },
  },
}
</script>
